import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#25da3c",
        secondary: "#FF8300",
        tertiary: colors.pink.base,
        ts_dark_grey: "#555555",
        bg_light: "#F4F4F4",
        accent: colors.shades.black,
        error: colors.red.accent3,
        app_background: colors.white,
      },
      dark: {
        primary: colors.blue.lighten3,
      },
    },
  },
});
